import calcRouteModule from './calc-route.module.js';

export default calcRouteModule;
